import { useDroppable } from '@dnd-kit/core';

if (typeof document !== 'undefined') {
  const styleId = 'droppable-column-thin-scroll';
  if (!document.getElementById(styleId)) {
    const styleElement = document.createElement('style');
    styleElement.id = styleId;
    styleElement.textContent = `
      .droppable-column-scroll { scrollbar-width: thin; scrollbar-color: #d0d0d0 transparent; }
      .droppable-column-scroll::-webkit-scrollbar { width: 5px; }
      .droppable-column-scroll::-webkit-scrollbar-track { background: transparent; }
      .droppable-column-scroll::-webkit-scrollbar-thumb { background: #d0d0d0; border-radius: 4px; }
      .droppable-column-scroll::-webkit-scrollbar-thumb:hover { background: #b0b0b0; }
    `;
    document.head.appendChild(styleElement);
  }
}

const DroppableColumn = ({ id, children, style , statusColor}) => {
  const { setNodeRef, isOver } = useDroppable({
    id: id,
  });

  const activeStyle = {
    ...style,
    border: isOver ? `2px solid ${statusColor}` : style.border,
    backgroundColor: "#f9f9f9",
    transition: 'all 0.2s ease'
  };

  return (
    <div ref={setNodeRef} className="droppable-column-scroll" style={activeStyle}>
      {children}
    </div>
  );
};

export default DroppableColumn;